class LottiePlayer extends HTMLElement {
  isPlaying = false;
  constructor() {
    super();
    this.data = this.extractData();
    if (this.data.autoplay) {
      this.play();
    }
  }

  extractData() {
    const id = this.getAttribute('id');
    const src = this.getAttribute('src');

    if (!id) {
      console.error('[LottiePlayer] Missing loading animation id!');
      return null;
    }
    if (!src) {
      console.error('[LottiePlayer] Missing loading animation path!');
      return null;
    }

    return {
      id,
      path: src,
      loop: this.getAttribute('loop') === 'true',
      fullscreen: this.getAttribute('fullscreen') === 'true',
      autoplay: this.getAttribute('autoplay') === 'true',
      width: this.getAttribute('width') || '100%',
      height: this.getAttribute('height') || '100%',
      speed: parseFloat(this.getAttribute('speed')) || 1,
      container: this,
    };
  }

  setup() {
    if (!this.data) return;
    const { id, ...animationProps } = this.data;
    this.instance = lottie.loadAnimation({
      ...animationProps,
      autoplay: true,
    });
    this.parentNode.classList.add('relative');
    let classList = [
      'top-0',
      'bottom-0',
      'left-0',
      'right-0',
      'w-full',
      'h-full',
      'bg-neutral-50/30',
      'z-50',
      'flex',
      'items-center',
      'justify-center',
      'pointer-events-auto',
    ];

    if (this.data.fullscreen) {
      classList = classList.concat([
        'fixed',
        '[&>svg]:!w-[30%]',
        '[&>svg]:!h-[30%]',
      ]);
    } else {
      classList = classList.concat(['absolute']);
    }

    this.className = classList.join(' ');
  }

  destroy() {
    this.instance?.destroy();
    this.instance = null;
  }

  stop() {
    if (!this.isPlaying) return;
    this.isPlaying = false;
    this.classList.add('hidden');
    this.destroy();
  }

  play() {
    if (this.isPlaying) return;
    this.setup();
    this.isPlaying = true;
    this.classList.remove('hidden');
  }

  toggle() {
    if (this.isPlaying) {
      this.stop();
    } else {
      this.play();
    }
  }
}
customElements.define('lottie-player', LottiePlayer);
